var map = {
	"./back-red.svg": "edbc",
	"./back-white.svg": "e932",
	"./cross-red.svg": "8879",
	"./cross-white.svg": "4f6c",
	"./dislike-red.svg": "0299",
	"./dislike-white.svg": "c704",
	"./dislike-yellow.svg": "ce8d",
	"./dropdown.svg": "8cc0",
	"./error-red.svg": "4092",
	"./eye-close.svg": "b675",
	"./eye-open.svg": "95c6",
	"./girl-and-pet.svg": "9d53",
	"./hamburger-lines.svg": "681a",
	"./heart-red-fill.svg": "f9d1",
	"./heart-red.svg": "b033",
	"./heart-white-fill.svg": "d220",
	"./heart-white.svg": "aed3",
	"./images-search.svg": "7b37",
	"./like-green.svg": "6d57",
	"./like-red.svg": "d529",
	"./like-white.svg": "79d6",
	"./pet-breeds.svg": "aaa0",
	"./pic.svg": "e6d2",
	"./search-ico.svg": "a2c1",
	"./sort-az-grey.svg": "239a",
	"./sort-az-red.svg": "b9c6",
	"./sort-za-grey.svg": "9d6e",
	"./sort-za-red.svg": "d28b",
	"./success-green.svg": "82d4",
	"./update-red.svg": "10a4",
	"./update-white.svg": "9e1d",
	"./upload-red.svg": "798b",
	"./upload-white.svg": "32c2",
	"./uploading-white.svg": "086d",
	"./vote-table.svg": "81e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";